<template>
  <div class="kefu-page">
    <div class="kefu-section">
      <div class="section-title">7×24在线客服</div>
      <p class="section-desc">专业客服在线对话，为您解决遇到的问题。</p>
      <div class="online-btn" :class="{ disabled: !kfOnlineSwitch }" @click="goOnlineKefu">
        <img src="/static/newImg/notice/imageAvatar12@3x.png" style="width:0.85rem;height:0.85rem" />
        <span>在线客服</span>
      </div>
    </div>
    <div class="kefu-section">
      <div class="kefu-tabs">
        <div class="kefu-tab" :class="{ active: activeTab === 0 }" @click="activeTab = 0">
          <img src="/static/newImg/notice/icon_im_telegram.avif" style="width:0.54rem;height:0.54rem" />
          <span style="font-size:0.35rem;">Telegram客服</span>
        </div>
        <div class="kefu-tab" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
          <img src="/static/newImg/notice/icon_kf_im.avif" style="width:0.54rem;height:0.54rem" />
          <span style="font-size:0.35rem;">其他客服</span>
        </div>
      </div>
      <div class="contact-section" v-if="activeTab === 0">
        <div class="contact-info" v-for="(item, idx) in telegramList" :key="'tg'+idx">
          <img src="/static/newImg/notice/icon_im_telegram.avif" style="width:0.8rem;height:0.8rem;border-radius:50%" />
          <div class="contact-detail">
            <div class="contact-name">昵称：<strong style="color:#fff;">{{ item.name }}</strong></div>
            <div class="contact-id">{{ item.account }} <img src="/static/newImg/index/copy01.png" class="copy-icon" @click.stop="copyAccount(item.account)" /></div>
            <div class="contact-time">在线时间：{{ item.online_time || '00:00 - 23:59' }}</div>
          </div>
          <div class="contact-btn" @click="contactKefu(item)">立即联系</div>
        </div>
        <div v-if="!telegramList.length" class="empty-tip">暂无客服</div>
      </div>
      <div class="contact-section" v-if="activeTab === 1">
        <div class="contact-info" v-for="(item, idx) in otherList" :key="'ot'+idx">
          <img :src="getAccountTypeIcon(item.account_type)" style="width:0.8rem;height:0.8rem;border-radius:50%" />
          <div class="contact-detail">
            <div class="contact-name">昵称：<strong style="color:#fff;">{{ item.name }}</strong></div>
            <div class="contact-id">{{ item.account }} <img src="/static/newImg/index/copy01.png" class="copy-icon" @click.stop="copyAccount(item.account)" /></div>
            <div class="contact-time">在线时间：{{ item.online_time || '00:00 - 23:59' }}</div>
          </div>
          <div class="contact-btn" @click="contactKefu(item)">立即联系</div>
        </div>
        <div v-if="!otherList.length" class="empty-tip">暂无客服</div>
      </div>
    </div>
    <div class="kefu-section help-section">
      <div class="help-header">
        <div class="help-title">帮助中心</div>
        <div class="help-search">
          <input v-model="searchKeyword" type="text" placeholder="请输入您的问题" @keyup.enter="submitSearch" />
          <van-icon name="search" @click="submitSearch" style="cursor:pointer;" />
          <van-icon v-if="searchKeyword || submittedKeyword" name="clear" class="search-clear" @click="clearSearch" />
        </div>
      </div>
      <div v-if="!submittedKeyword" class="help-tags">
        <span class="help-tag" :class="{ active: helpTab === idx }" v-for="(cat, idx) in helpCategoryList" :key="'hc'+idx" @click="helpTab = idx">
          <img v-if="cat.icon" :src="cat.icon" class="tag-icon-img" />
          <svg v-else class="tag-icon" viewBox="0 0 40 40" v-html="getDefaultIconSvg(idx)"></svg>{{ cat.name }}
        </span>
      </div>
      <div class="help-list">
        <template v-if="submittedKeyword">
          <div class="help-list-item" v-for="(item, i) in searchResults" :key="'s'+i" @click="showHelpDetail(item)">
            <span v-html="highlightTitle(i + 1, item.title)"></span>
            <van-icon name="arrow" />
          </div>
          <div v-if="!searchResults.length" class="empty-tip">暂无匹配内容</div>
        </template>
        <template v-else>
          <div class="help-list-item" v-for="(item, i) in currentHelpItems" :key="i" @click="showHelpDetail(item)">
            <span>{{ i + 1 }}、{{ item.title }}</span>
            <van-icon name="arrow" />
          </div>
          <div v-if="!currentHelpItems.length" class="empty-tip">暂无内容</div>
        </template>
      </div>
    </div>

    <!-- 帮助详情弹框 -->
    <div class="help-detail-overlay" v-if="helpDetailShow" @click.self="helpDetailShow = false">
      <div class="help-detail-popup">
        <div class="detail-header">
          <van-icon name="arrow-left" @click="helpDetailShow = false" />
          <span class="detail-title">{{ helpDetailTitle }}</span>
        </div>
        <div class="detail-content" v-html="helpDetailContent"></div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'noticeKefu',
  data() {
    return {
      activeTab: 0,
      helpTab: 0,
      helpDetailShow: false,
      helpDetailTitle: '',
      helpDetailContent: '',
      telegramList: [],
      otherList: [],
      kfOnlineUrl: '',
      kfOnlineSwitch: 1,
      helpCategoryList: [],
      searchKeyword: '',
      submittedKeyword: ''
    }
  },
  computed: {
    currentHelpItems() {
      return this.helpCategoryList[this.helpTab] && this.helpCategoryList[this.helpTab].items ? this.helpCategoryList[this.helpTab].items : [];
    },
    searchResults() {
      const kw = (this.submittedKeyword || '').trim().toLowerCase();
      if (!kw) return [];
      const results = [];
      this.helpCategoryList.forEach(cat => {
        if (cat.items && cat.items.forEach) {
          cat.items.forEach(item => {
            const title = (item.title || '').toLowerCase();
            if (title.indexOf(kw) > -1) {
              results.push(item);
            }
          });
        }
      });
      return results;
    }
  },
  mounted() {
    this.getKefuList();
    this.getAppConfig();
    this.getHelpList();
  },
  methods: {
    getDefaultIconSvg(idx) {
      const defaults = [
        '<rect x="4" y="6" width="32" height="22" rx="3" fill="#4A90D9"/><rect x="14" y="30" width="12" height="3" rx="1" fill="#4A90D9"/><rect x="10" y="34" width="20" height="2" rx="1" fill="#4A90D9"/>',
        '<rect x="2" y="10" width="36" height="20" rx="4" fill="#4A90D9"/><text x="20" y="26" text-anchor="middle" fill="#fff" font-size="14" font-weight="bold">No</text>',
        '<circle cx="20" cy="20" r="16" fill="#4CAF50"/><circle cx="20" cy="20" r="10" fill="none" stroke="#fff" stroke-width="2"/><text x="20" y="25" text-anchor="middle" fill="#fff" font-size="14" font-weight="bold">¥</text>',
        '<rect x="6" y="16" width="28" height="20" rx="2" fill="#9C27B0"/><rect x="6" y="16" width="28" height="6" rx="2" fill="#AB47BC"/><path d="M14 16V10a6 6 0 0112 0v6" stroke="#9C27B0" stroke-width="3" fill="none"/><line x1="20" y1="16" x2="20" y2="36" stroke="#7B1FA2" stroke-width="2"/>',
        '<path d="M8 22c0-4 3-7 7-7 2 0 4 1 5 3 1-2 3-3 5-3 4 0 7 3 7 7 0 3-2 5-4 7l-8 6-8-6c-2-2-4-4-4-7z" fill="#2196F3"/>',
        '<circle cx="20" cy="20" r="14" fill="none" stroke="#F44336" stroke-width="2.5"/><text x="20" y="27" text-anchor="middle" fill="#F44336" font-size="18" font-weight="bold">?</text>'
      ];
      return defaults[idx] || defaults[5];
    },
    getHelpList() {
      const that = this;
      that.$apiFun.post('/api/helplist', {}).then(res => {
        if (res.code === 200) {
          that.helpCategoryList = res.data.list || [];
        }
      });
    },
    getKefuList() {
      const that = this;
      that.$apiFun.post('/api/kefulist', {}).then(res => {
        if (res.code === 200) {
          that.telegramList = res.data.telegram_list || [];
          that.otherList = res.data.other_list || [];
        }
      });
    },
    getAppConfig() {
      const that = this;
      that.$apiFun.post('/api/app', {}).then(res => {
        if (res.code === 200) {
          const switchVal = res.data.kf_online_switch;
          that.kfOnlineSwitch = switchVal != null ? (switchVal == 1 || switchVal == '1') : true;
          that.kfOnlineUrl = res.data.kf_online_url || '';
        }
      });
    },
    goOnlineKefu() {
      if (this.kfOnlineSwitch && this.kfOnlineUrl) {
        window.open(this.kfOnlineUrl, '_blank');
      }
    },
    getAccountTypeIcon(accountType) {
      if (accountType == 1) {
        return '/static/newImg/notice/icon_im_telegram.avif';
      } else if (accountType == 2) {
        return '/static/newImg/notice/1927322810833989633.avif';
      } else if (accountType == 3) {
        return '/static/newImg/notice/1858791834433339394.avif';
      }
      return '/static/newImg/notice/icon_kf_im.avif';
    },
    contactKefu(item) {
      if (item.account_type == 1) {
        if (item.account) {
          window.open('https://t.me/' + item.account.replace('@', ''), '_blank');
        }
      } else if (item.account_type == 2) {
        if (item.account) {
          window.open('tel:' + item.account, '_blank');
        }
      } else if (item.account_type == 3) {
        if (item.account) {
          window.open('mailto:' + item.account, '_blank');
        }
      } else {
        if (item.account) {
          window.open(item.account, '_blank');
        }
      }
    },
    copyAccount(account) {
      if (!account) return;
      const cInput = document.createElement('input');
      cInput.style.position = 'fixed';
      cInput.style.top = '0';
      cInput.style.left = '-9999px';
      cInput.style.opacity = '1';
      cInput.style.display = 'block';
      cInput.value = String(account);
      document.body.appendChild(cInput);
      cInput.focus();
      cInput.setSelectionRange(0, cInput.value.length);
      let ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) { ok = false; }
      try { document.body.removeChild(cInput); } catch (e) {}
      const notify = (this.$root && this.$root.showTost)
        || (this.$parent && this.$parent.showTost)
        || (this.$parent && this.$parent.$parent && this.$parent.$parent.showTost);
      if (notify) {
        notify.call(this.$root || this, ok ? 1 : 0, ok ? '复制成功！' : '复制失败');
      }
    },
    showHelpDetail(item) {
      this.helpDetailTitle = item.title;
      this.helpDetailContent = item.content ? item.content.replace(/\n/g, '<br/>') : '';
      this.helpDetailShow = true;
    },
    escapeRegExp(str) {
      return (str || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    submitSearch() {
      this.submittedKeyword = (this.searchKeyword || '').trim();
    },
    clearSearch() {
      this.searchKeyword = '';
      this.submittedKeyword = '';
    },
    highlightTitle(index, title) {
      const kw = (this.submittedKeyword || '').trim();
      const prefix = index + '、';
      if (!kw) return prefix + (title || '');
      const safeKw = this.escapeRegExp(kw);
      const reg = new RegExp(safeKw, 'gi');
      const hTitle = (title || '').replace(reg, match => {
        return '<span style="color:#dfb372;">' + match + '</span>';
      });
      return prefix + hTitle;
    }
  }
}
</script>

<style lang="scss" scoped>
.kefu-page {
  padding: 0.3rem;
  color: #fff;
}
.kefu-section {
  background: #292A2C;
  border-radius: 0.2rem;
  padding: 0.3rem;
  margin-bottom: 0.3rem;
}
.kefu-tabs {
  display: flex;
  gap: 0.5rem;
  border-bottom: 1px solid #3B3C3D;
  padding-bottom: 0.2rem;
  .kefu-tab {
    display: flex;
    align-items: center;
    gap: 0.1rem;
    font-size: 0.3rem;
    color: #fff;
    cursor: pointer;
    padding-bottom: 0.1rem;
    &.active {
      color: #DFB372;
      border-bottom: 2px solid #DFB372;
    }
  }
}
.section-title {
  font-size: 0.35rem;
  font-weight: bold;
  margin-bottom: 0.1rem;
}
.section-desc {
  font-size: 0.3rem;
  color: #999;
  margin-top:0.2rem;
  margin-bottom: 0.2rem;
}
.online-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.1rem;
  padding: 0.15rem 0.3rem;
  border: 1px solid #DFB372;
  border-radius: 0.1rem;
  color: #DFB372;
  font-size: 0.28rem;
  cursor: pointer;
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
.telegram-row {
  display: flex;
  gap: 0.3rem;
  .tg-item {
    display: flex;
    align-items: center;
    gap: 0.1rem;
    font-size: 0.28rem;
  }
}
.contact-section {
  .contact-info {
    display: flex;
    align-items: center;
    gap: 0.2rem;
    margin-top: 0.3rem;
    .contact-detail {
      flex: 1;
      line-height: 0.5rem;
      .contact-name { font-size: 0.35rem; color:#666;}
      .contact-id {
        font-size: .32rem;
        color: #fff;
        display: flex;
        align-items: center;
        gap: 0.12rem;
        .copy-icon {
          width: 0.45rem;
          height: 0.45rem;
          display: inline-block;
          cursor: pointer;
          vertical-align: middle;
        }
      }
      .contact-time { font-size: 0.3rem; color: #666; }
    }
    .contact-btn {
      padding: 0.15rem 0.3rem;
      background: #DFB372;
      color: #1E1F24;
      border-radius: 0.1rem;
      font-size: 0.26rem;
      white-space: nowrap;
      cursor: pointer;
    }
  }
  .empty-tip {
    text-align: center;
    color: #666;
    font-size: 0.3rem;
    padding: 0.5rem 0;
  }
}
.help-section {
  .help-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.2rem;
    .help-title { font-size: 0.35rem; font-weight: bold; }
    .help-search {
      display: flex;
      align-items: center;
      background: #1E1F24;
      border: 1px solid #555;
      border-radius: 0.5rem;
      padding: 0.15rem 0.3rem 0.15rem 0.5rem;
      width: 4.8rem;
      margin-left: 0.3rem;
      input {
        background: transparent;
        border: none;
        outline: none;
        color: #fff;
        font-size: 0.3rem;
        flex: 1;
        &::placeholder { color: #666; font-size: 0.3rem; }
      }
      .van-icon { color: #DFB372; flex-shrink: 0; font-size: 0.45rem; }
      .search-clear {
        color: #999;
        font-size: 0.45rem;
        margin-left: 0.1rem;
        cursor: pointer;
        flex-shrink: 0;
      }
    }
  }
  .help-tags {
    display: flex;
    gap: 0.15rem;
    overflow-x: auto;
    white-space: nowrap;
    margin-bottom: 0.3rem;
    padding-bottom: 0.1rem;
    &::-webkit-scrollbar { display: none; }
    .help-tag {
      display: inline-flex;
      align-items: center;
      gap: 0.08rem;
      padding: 0.1rem 0.25rem;
      background: #3b3c3d;
      color: #969799;
      border-radius: 0.1rem;
      font-size: 0.3rem;
      cursor: pointer;
      flex-shrink: 0;
      .tag-icon { width: 0.65rem; height: 0.65rem; flex-shrink: 0; }
      .tag-icon-img { width: 0.65rem; height: 0.65rem; flex-shrink: 0; border-radius: 0.1rem; }
      &.active {
        background: #DFB372;
        color: #1E1F24;
      }
    }
  }
  .help-list {
    .help-list-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.2rem 0;
      border-bottom: 1px solid #3B3C3D;
      font-size: 0.28rem;
      .van-icon { color: #666; }
    }
  }
}
.help-detail-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.7);
  z-index: 1000;
  .help-detail-popup {
    width: 100%;
    background: #1E1F24;
    min-height: 100vh;
    margin-top: 30%;
    .detail-header {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.4rem 0;
      position: relative;
      .van-icon {
        position: absolute;
        left: 0.2rem;
        font-size: 0.45rem;
        color: #969799;
      }
      .detail-title {
        font-size: 0.35rem;
        font-weight: bold;
        color: #fff;
      }
    }
    .detail-content {
      font-size: 0.35rem;
      color: #969799;
      line-height: 1.8;
      padding: 0 0.2rem;
      img { max-width: 100%; }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/notice/kefu.vue